import { infoCircleIcon } from "../../elements/icons/index.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 * A Twitter Bootstrap control-group for Horizontal forms.
 *
 * @param {object} spec - The specification object
 * @param {object} spec.fields - Form fields to render
 * @param {string} spec.label - Label for group
 * @param {string} spec.labelfor - Value on label 'for' attribute. Should be an
 *   id for one of the fields
 * @param {object[]} spec.objects - initial objects to render
 * @param {object} my - The internal state object
 */
export default function controlGroup(spec, my) {
	my ||= {};
	spec ||= {};

	const that = widget(spec, my);

	const label = spec.label;
	const labelfor = spec.labelfor;
	const helpCallback = spec.helpCallback;

	const labelClass = spec.labelClass || "col-sm-2";
	const inputClass = spec.inputClass || "col-sm-10";

	// form field widgets in group
	const fields = [];

	// objects to render inside control group div
	const objects = spec.objects || [];

	// div that wrapp objects
	my.controlGroupDiv = null;

	if (spec.fields) {
		spec.fields.forEach((field) => {
			addField(field);
		});
	}

	function addField(formField) {
		if (
			!formField ||
			!formField.register ||
			!formField.valid ||
			!formField.enabled
		) {
			throw "formFieldWidget must be a valid form field";
		}

		// add field
		objects.push(formField);
		fields.push(formField);

		// validate group if state change in formFieldWidget
		formField.register("validationStateChange", () => {
			that.validate();
		});
	}

	// group is invalid if any enabled field is invalid
	that.validate = function () {
		const hasErrors = fields.some(
			(field) => !field.valid() && field.enabled(),
		);

		that.validationState(hasErrors ? "error" : "");

		return hasErrors;
	};

	that.validationState = function (val) {
		if (!my.controlGroupDiv) {
			return;
		}

		my.controlGroupDiv.removeClass(
			"has-error has-warning has-info has-success",
		);

		my.controlGroupDiv.addClass(`has-${val}`);
	};

	// Append a field
	that.appendField = addField;

	// Append any rendable object (see htmlCanvas for valid objects)
	that.append = function (obj) {
		objects.push(obj);
	};

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	my.labelContentRenderer = function (label = "") {
		if (!helpCallback) {
			return label;
		}

		return (html) =>
			html.a(
				{ "data-toggle": "modal", click: helpCallback },
				label,
				" ",
				infoCircleIcon({ dataTest: "help-icon" }),
			);
	};

	my.renderLabelOn = function (html) {
		const groupLabel = html.label(
			{ klass: ["control-label", labelClass] },
			my.labelContentRenderer(label),
		);

		if (labelfor) {
			groupLabel.attr({ for: labelfor });
		}

		return groupLabel;
	};

	that.renderContentOn = function (html) {
		my.controlGroupDiv = html.div(
			{ klass: "form-group" },
			my.renderLabelOn,
			html.div({ klass: inputClass }, objects),
		);
	};

	return that;
}
